export default __webpack_public_path__ + "KaTeX_Main-Bold.07e762d041b580e5d32ae14a9cb27450.ttf";